import { Badge, Stack, Typography } from '@mui/material';
import React, { ReactElement, ReactNode, useEffect, useState } from 'react';
import {
  TabBodyWrapper,
  TabHeaderItemCurl,
  TabHeaderItemCurlMask,
  TabHeaderItemWrapper,
  TabHeaderWrapper,
} from './Tab.styles';

export interface TabOption {
  label: string;
  value: string;
}

export interface TabProps {
  renderHeaderAction?: () => ReactNode;
  options: TabOption[];
  value?: string;
  onChange?: (newVal: string) => void;
  children?: ReactNode;
  isTabDisabled?: (value: string) => boolean;
  needBadge?: boolean
}

export const Tab = ({
  options,
  value,
  onChange,
  children,
  renderHeaderAction,
  isTabDisabled,
}: TabProps): ReactElement => {
  const [opt, setOpt] = useState<TabOption[]>([]);

  useEffect(() => {
    setOpt(options);
  }, [options]);

  const bindTabHeader = (opt: string, disabled?: boolean) => {
    if (disabled) {
      return {
        selected: opt === value,
        disabled: true,
      };
    }
    return {
      onClick: () => {
        if (onChange) onChange(opt);
      },
      selected: opt === value,
    };
  };

  const getMaskDirection = (item: TabOption, idx: number): 'left' | 'right' | 'none' => {
    if (item.value === value) {
      return 'left';
    } else if (opt[idx + 1].value === value) {
      return 'right';
    } else {
      return 'none';
    }
  };
  
  return (
    <div>
      <TabHeaderWrapper>
        {opt.map((el, idx) => (
          <React.Fragment key={idx}>
            <TabHeaderItemWrapper {...bindTabHeader(el.value, isTabDisabled ? isTabDisabled(el.value) : undefined)}>
              <Stack direction={'row'} spacing={4} alignItems="center">
                <Typography sx={{ color: 'inherit', fontSize: '20px', position: 'relative' }}>
                  {el.label}
                </Typography>

                {el.value === value && renderHeaderAction && renderHeaderAction()}
              </Stack>
            </TabHeaderItemWrapper>
            {idx !== opt.length - 1 && (
              <TabHeaderItemCurl>
                <TabHeaderItemCurlMask direction={getMaskDirection(el, idx)} />
              </TabHeaderItemCurl>
            )}
          </React.Fragment>
        ))}
      </TabHeaderWrapper>
      <TabBodyWrapper
        firstSelected={opt.length > 0 && opt[0].value === value}
        lastSelected={opt.length > 0 && opt[opt.length - 1].value === value}
      >
        {children}
      </TabBodyWrapper>
    </div>
  );
};
